import styled from 'styled-components';
import {DEVICE} from '@chekin/guestapp-ui-kit';
import {Button, CustomIcon} from '@guestapp/old-ui-kit';
import {FormFieldWrapper} from 'styled/common';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 0;
  width: 100%;

  @media (min-width: ${DEVICE.laptop}) {
    margin-top: 48px;
  }
`;

export const CustomBackButton = styled(Button)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 32px;

  & .button__left-icon {
    padding-right: 10px;
  }
`;

export const ContentButton = styled.div`
  display: flex;
  align-items: center;
  margin: 48px auto;

  @media (min-width: ${DEVICE.laptop}) {
    margin: 24px 0 48px 0;
  }
`;

export const StyledBackIcon = styled(CustomIcon)`
  display: flex;
  justify-content: center;
  align-items: center;

  path {
    fill: ${({theme}) =>
      theme.hasTemplate
        ? theme.colors.branding.icons
        : theme.colors.navigationMenu.selectedItemText};
  }
`;

export const StyledFormFieldWrapper = styled(FormFieldWrapper)`
  & .fieldset__label {
    text-transform: none;
  }
`;
